import React, { useMemo } from "react";
import { useCallback } from "react";
import { useController } from "react-hook-form";
import Chip from "../Chip";
import { ColumnGap, FormItemContainer } from "../StyledComponents";

const ChipsGroup = ({ name, control, onChangeDefault, placeholder, id, handlePlaceholder = null }) => {
  const {
    field: { value, onChange },
  } = useController({ control, name });

  const handleChip = useCallback(
    (currentId) => {
      onChange(
        value?.map((i) => {
          if ((i[id] || i.id) === currentId) {
            i.disabled = !i.disabled;
          }
          return i;
        })
      );
    },
    [value, onChange, id]
  );

  const renderItems = useMemo(() => {
    if (!value?.length) {
      return <></>;
    }

    return (
      <ColumnGap flexDirection="column" >
        {value?.map((item, idx) => (
          <Chip
            fontSize={14}
            key={`${idx}`}
            disabled={item.disabled}
            {...{ name, control, onChangeDefault }}
            id={item[id] || item.id}
            placeholder={!!handlePlaceholder ? handlePlaceholder(item) : item[placeholder]}
            onChange={handleChip}
          />
        )) || <div />}
      </ColumnGap>
    );
  }, [control, name, onChangeDefault, value, handleChip, placeholder, id, handlePlaceholder]);

  return <FormItemContainer style={{height: '100%'}} >{renderItems}</FormItemContainer>;
};

export default ChipsGroup;
